// extracted by mini-css-extract-plugin
export default {"warning":"HistoryItemStatus__warning___CfBje","wrapper":"HistoryItemStatus__wrapper___T57ps"};